<div class="notifications">
  <div (click)="hide(note)" class="{{ note.type }}"
    *ngFor="let note of notes">
    {{ note.text }}
  </div>
</div>

